
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { Script } from "@/models/script";
import { CompanyService } from "@/services/company-service";
import { CompanyDossierService } from "@/services/company-dossier-service";
import { ScriptService } from "@/services/script-service";
import "codemirror/mode/javascript/javascript";
import AppDossierScriptShowProperties from "@/components/dossier/DossierScriptShowProperties.vue";

export default Vue.extend({
	data(){
		return {
			company: new Company(),
			dossier: new Dossier(),
			script: new Script(),
			ready: false,
			propertiesModal: false
		};
	},
	computed: {
		cmOptions():any{
			return {
				mode: "text/javascript",
				readOnly: true,
				theme: "base16-light"
			};
		}
	},
	methods: {
		goBackToScripts(){
			this.$router.push( {path: `/companies/${this.company.id}/dossier/${this.dossier.id}/info`,query: { currentTab: "2" } });
		},
		showScriptProperties(){
			this.propertiesModal = true;
		},
		toEditPage(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.dossier.id}/scripts/edit/${this.script.ID}`);
		},
		//custom esc Button event
		escButtonEvent(ev:KeyboardEvent){
			if (ev.key === "Escape") {
				this.propertiesModal= false;
			}
			return;
		}
	},
	async created(){
		let companyId = parseInt(this.$route.params.companyId);
		let dossierId = parseInt(this.$route.params.dossierId);
		this.company = await CompanyService.getCompany(companyId);
		this.dossier = await CompanyDossierService.getDossier(companyId, dossierId);
		let scriptId = parseInt(this.$route.params.scriptId || "0");
		if (scriptId != 0){
			this.script = await ScriptService.getScript(this.dossier.id, scriptId);
		}
		this.ready = true;
	},
	mounted() {
		window.addEventListener("keyup",this.escButtonEvent);
	},
	beforeDestroy(){
		window.removeEventListener("keyup", this.escButtonEvent);
	},
	components: {
		AppDossierScriptShowProperties
	}
});
